import { connect } from 'react-redux';
import {
    loginStateSelector,
    userSelector,
} from '@zocdoc-frontend-common/state-user-account/selectors';
import NotificationMenuContainer from './NotificationMenuContainer';

export function mapStateToProps(state) {
    const loginState = loginStateSelector(state);
    const user = userSelector(state);

    return {
        loginState,
        count: user.unseen_notification_count,
        userType: user.user_type,
    };
}

export default connect(mapStateToProps)(NotificationMenuContainer);
